<div class="signatore-label">
  <mat-icon
    [ngStyle]="{
      color: (isEndorsement && statusClient && statusClientEndorsement) || (!isEndorsement && statusClient) ? colors.GREEN : colors.YELLOW
    }"
  >
    circle
  </mat-icon>
  <span
    class="text-status"
    [ngStyle]="{
      color: (isEndorsement && statusClient && statusClientEndorsement) || (!isEndorsement && statusClient) ? colors.GREEN : colors.YELLOW
    }"
  >
    <ng-container *ngIf="isEndorsement; else notEndorsement">
      <ng-container
        *ngIf="statusClient && statusClientEndorsement; else elseTemplate"
      >
        Documento firmado
      </ng-container>
      <ng-template #elseTemplate>
        <ng-container
          *ngIf="statusClient && !statusClientEndorsement"
        >
          Documento pendiente de firmar por aval
        </ng-container>
        <ng-container
          *ngIf="!statusClient && statusClientEndorsement"
        >
          Documento pendiente de firmar por cliente
        </ng-container>
        <ng-container
          *ngIf="!statusClient && !statusClientEndorsement"
        >
          Documento pendiente de firmar por cliente y aval
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-template #notEndorsement>
      {{
        statusClient ? "Documento firmado" : "Pendiente de firmar por cliente"
      }}
    </ng-template>
  </span>
</div>
